import React from 'react';
import { BaseInputProps } from './types';
import { useInputHelper } from './inputHelper';
import { TextInput } from './TextInput';

export interface NumberProps extends BaseInputProps<number> {

}

export function NumberInput(props: NumberProps) {
  const helper = useInputHelper<number>(props);

  return (
    <TextInput
      {...helper.getBaseInputLayoutProps()}
      source={props.source}
      value={helper.getValue()
      ?.toString() || undefined}
      onChangeCallback={(data) => {
        const stringValue = data?.[props.source];

        let value;

        if (stringValue) {
          value = parseInt(stringValue.replace(/\D/g, ''), 10);
        } else {
          value = undefined;
        }

        helper.getOnChangeCallback()({
          target: {
            value,
          },
        });
      }}
      mobile_keyboardType="number-pad"
    />
  );
}
